
import { Vue, Component } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';

@Component
export default class CopyKaTemplateModal extends Vue {
  visible = false;

  Pdata: any = '';

  @lazyInject(BrandService)
  protected brandService!: BrandService;

  formData: any = {
    template_name: '',
    from_template_id: '',
  };
  init(val: any) {
    this.Pdata = val;
    this.formData.from_template_id = val.template_id;
    this.visible = true;
  }
  async handleOk() {
    const res = await this.brandService.brandAlbumKaTemplateCopy(this.formData);
    if (res) {
      this.$message.success('复制成功');
      this.visible = false;
      this.$emit('success');
    }
  }
  close() {
    this.visible = false;
  }
  handleCancel() {
    this.visible = false;
  }
}
